import React, { useEffect } from 'react';
import { Button, Card, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FaBan, FaCheck, FaPen } from 'react-icons/fa';

const InfoCotisationSel = ({ cotisation, choix_id, paiement_en_x_fois, handleModifiable }) => {

    useEffect(() => {
        console.log('cotisation', cotisation);
    }
        , [cotisation]);

    const ExpandedComponent = () => {

        let myChoix = JSON.parse(cotisation.choix);

        return <Card>
            <Table striped bordered hover style={{ margin: 'auto', }}>
                <thead>
                    <tr>
                        {/* <th>Ordre</th> */}
                        <th>Libelle</th>
                        <th>Montant</th>
                        {cotisation.trois_fois === 1 && <th>En 3 fois</th>}
                        {cotisation.six_fois === 1 && <th>En 6 fois</th>}
                    </tr>
                </thead>
                <tbody>
                    {
                        myChoix.filter(el => choix_id === el.id).map((e) => (
                            <tr>
                                {/* <td style={{ backgroundColor: choix_id === e.id ? 'bisque' : '' }}>{e.libelle}</td>
                                <td style={{ backgroundColor: choix_id === e.id ? 'bisque' : '' }}>{e.montant}&nbsp;€</td>
                                {cotisation.trois_fois === 1 && <td style={{ backgroundColor: choix_id === e.id ? 'bisque' : '' }}>{Math.ceil(e.montant / 3)}&nbsp;€</td>}
                                {cotisation.six_fois === 1 && <td style={{ backgroundColor: choix_id === e.id ? 'bisque' : '' }}>{Math.ceil(e.montant / 6)}&nbsp;€</td>} */}

                                <td style={{ backgroundColor: choix_id === e.id ? 'bisque' : '' }}>{e.libelle} - {paiement_en_x_fois}</td>
                                <td style={{ backgroundColor: choix_id === e.id ? (paiement_en_x_fois && paiement_en_x_fois === 1 ? 'lightblue' : 'bisque') : '' }}>{e.montant}&nbsp;€</td>
                                {cotisation.trois_fois === 1 && <td style={{ backgroundColor: choix_id === e.id ? (paiement_en_x_fois && paiement_en_x_fois === 3 ? 'lightblue' : 'bisque') : '' }}>{Math.ceil(e.montant / 3)}&nbsp;€</td>}
                                {cotisation.six_fois === 1 && <td style={{ backgroundColor: choix_id === e.id ? (paiement_en_x_fois && paiement_en_x_fois === 6 ? 'lightblue' : 'bisque') : '' }}>{Math.ceil(e.montant / 6)}&nbsp;€</td>}
                            </tr>
                        ))
                    }
                </tbody>
            </Table>

        </Card>
            // <pre>{JSON.stringify(data.choix, null, 2)}</pre>
            ;
    }

    return (
        <Card>
            {cotisation && cotisation.choix && (<>
                <Card.Header>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                        <h4>{cotisation.reference} - {cotisation.titre}</h4>
                        <div style={{ flexGrow: 1 }} />
                        <Button variant='light' size='sm' onClick={() => handleModifiable()}><FaPen /></Button>
                    </div>
                </Card.Header>
                <Card.Body>
                    <h5>{cotisation.libelle}</h5>

                    {ExpandedComponent()}
                </Card.Body>
            </>)}
        </Card>
    );
}

export default InfoCotisationSel;
